// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"OrganisationChart_loaderOverlay__Fo6UB"};